import { Group, Stack } from '@mantine/core';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Colors } from '../patterns/Colors';

interface Props {
    splash?: ReactNode;
    children: ReactNode;
}

const Card = styled.div<{ single?: boolean }>`
    @media (min-width: 640px) {
        min-width: 32rem;
        width: ${({ single }) => (single ? '32rem' : '72rem')};
        // height: 42rem;
        max-width: 100%;
        display: grid;
        grid-template-columns: ${({ single }) => (single ? '1fr' : '1fr 1fr')};
        background: white;
        border-radius: 0.5rem;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        overflow: hidden;
    }
`;

const LeftPane = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 2rem;

    @media (min-width: 640px) {
        min-height: 0;
        height: 100%;
        overflow-y: auto;
    }
`;

const Content = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;

const FooterLink = styled.a`
    font-size: 0.75rem;
    color: ${Colors.primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const Bullet = styled.span`
    font-size: 0.75rem;
    color: ${Colors.primary};
`;

const Heading = styled.h2`
    margin: 0 0 .25em 0;
    font-size: 1.25rem;
    font-weight: 500;
    color: ${Colors.text};
`;

const Title = styled.h1`
    margin: 0 0 .25em 0;
    font-size: 1.5rem;
    font-weight: 500;
    color: ${Colors.text};
`;

const Copy = styled.div`
    margin: 0;
    color: ${Colors.textLight};
`;

const Base = ({ splash, children }: Props) => {
    return <Stack gap="md">
        <Card single={!splash}>
            <LeftPane>
                <Content>
                    {children}
                </Content>
            </LeftPane>
            {splash}
        </Card>
        <Group gap="xs" justify="center">
            <FooterLink href="https://spreo.io/privacy">Privacy</FooterLink>
            <Bullet>•</Bullet>
            <FooterLink href="https://spreo.io/terms">Terms</FooterLink>
            <Bullet>•</Bullet>
            <FooterLink href="https://spreo.io/security">Security</FooterLink>
        </Group>
    </Stack>;
};

export const PageCard = Object.assign(Base, {
    Title,
    Heading,
    Copy,
});
